import { render, staticRenderFns } from "./FileResultsPreview.vue?vue&type=template&id=9b3e0ec2&"
import script from "./FileResultsPreview.vue?vue&type=script&lang=ts&"
export * from "./FileResultsPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports